/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 異動履歴検索条件情報 <br>　異動履歴照会管理番号、使用お客さま番号、契約お客さま番号、請求お客さま番号、内部お客さま番号のいずれかの値が必須
 */
export interface IdouRirekiSearchCriteriaInfo { 
    /**
     * 異動履歴照会管理番号：数字
     */
    idouRirekiInquiryManagementNo?: string;
    /**
     * 異動種別区分：英数字 <br>　コード変換マスターテーブル.画面項目ID「C005390（異動種別区分）」のユーザコードを設定
     */
    idouTypeKbn?: string;
    /**
     * 異動種別大分類コード：英数字 <br>　コード変換マスターテーブル.画面項目ID「C013840（異動種別大分類コード）」のユーザコードを設定
     */
    idouTypeMajorCategoryCode?: string;
    /**
     * 使用お客さま番号：英数字
     */
    usingCustomerNo?: string;
    /**
     * 契約お客さま番号：英数字
     */
    contractCustomerNo?: string;
    /**
     * 請求お客さま番号：英数字
     */
    billingCustomerNo?: string;
    /**
     * 内部お客さま番号：英数字
     */
    internalCustomerNo?: string;
}

